import http from 'axios';

const GQL_ENDPOINT = process.env.VUE_APP_BACKEND_URL + '/graphql';

async function graphQL (query, variables) {
  let response
  let options = {}
  if (!!localStorage.getItem('token')) {
      options.headers = {
        "Authorization": "Bearer " + localStorage.getItem('token')
      }
  }

  try {
    response = await http.post(GQL_ENDPOINT, { query, variables }, options)
  } catch (ex) {
    throw ex;
  }

  return response.data;
}

const queries = {}
const mutations = {}

// Les différents appels graphQL
// Query
queries.myProfile = async function () {
  try {
    let response = await graphQL(`
    query MyProfile {
      me {
        id
        account_type
        title
        email
        phone
        first_name
        last_name
        birthdate
        avatar
        already_evaluated
        notif_mail
        notif_sms
        signup_date
        rights
        firstConnexion
        gender
        appointments {
          id
          title
          comment
          appointment_type
          date
        }
        games {
          id
          game
          score
          secure_key
        }
      }
    }`);
    return response.data
  } catch (ex) {
    throw ex
  }
}

queries.myGames = async function () {
  try {
    let response = await graphQL(`
    query MyGames {
    }`);
    return response.data
  } catch (ex) {
    throw ex
  }
}
queries.myFamily = async function () {
  try {
    let response = await graphQL(`
    query MyFamily {
      me {
        families {
          id
          parents {
            id
            avatar
            first_name
            last_name
          }
          relatives {
            id
            avatar
            first_name
            last_name
          }
          children {
            id
            avatar
            first_name
            last_name
            notifications {
              date
              notification_type
            }
          }
          friends {
            signup_date
            id
            identifier
            avatar
            first_name
            last_name
            signup_date
          }
          caregivers {
            id
            gender
            avatar
            first_name
            last_name
            signup_date
            title
          }
        }
      }
    }`);
    return response.data
  } catch (ex) {
    throw ex
  }
}
queries.myRelatives = async function () {
  try {
    let response = await graphQL(`
    query MyRelatives {
      me {
        families {
          id
          relatives {
            id
            avatar
            first_name
            last_name
            email
            phone
            identifier
            birthdate
            signup_date
            rights
            notif_mail
            notif_sms
          }
          children {
            id
            avatar
            first_name
            last_name
            email
            phone
            identifier
            birthdate
            notif_mail
            notif_sms
            rights
            notifications {
              date
              notification_type
              variables
            }
            auto_evaluations {
              date
              value
            }
          }
          caregivers {
            id
            gender
            avatar
            first_name
            last_name
            signup_date
            title
            can
          }
          invitedCaregivers {
            id
            gender
            avatar
            first_name
            last_name
            signup_date
            title
          }
          friends {
            id
            identifier
            avatar
            first_name
            last_name
            signup_date
          }
          invitedFriends {
            id
            identifier
            avatar
            first_name
            last_name
            signup_date
          }
        }
      }
    }`);
    return response.data
  } catch (ex) {
    throw ex
  }
}
queries.myChildren = async function () {
  try {
    let response = await graphQL(`
    query MyChildren {
      me {
        families {
          id
          children {
            id
            avatar
            first_name
            last_name
            email
            phone
            identifier
            birthdate
            notif_mail
            notif_sms
            rights
            notifications {
              date
              notification_type
              variables
            }
            auto_evaluations {
              date
              value
            }
          }
        }
      }
    }`);
    return response.data
  } catch (ex) {
    throw ex
  }
}
queries.childrenOnMyList = async function () {
  try {
    let response = await graphQL(`
    query ChildrenOnMyList {
      me {
        families {
          id
          can
          status
          children {
            id
            avatar
            first_name
            last_name
            identifier
            signup_date
            notifications {
              date
              notification_type
              variables
            }
            auto_evaluations {
              date
              value
            }
            games {
              id
              game
              played_at
            }
          }
          parents {
            id
            avatar
            first_name
            last_name
            appointments {
              appointment_type
              date
            }
          }
          relatives {
            id
            avatar
            first_name
            last_name
          }
          friends {
            signup_date
            id
            identifier
            avatar
            first_name
            last_name
          }
          caregivers {
            id
            gender
            avatar
            first_name
            last_name
            title
          }
        }
      }
    }`);
    return response.data
  } catch (ex) {
    throw ex
  }
}

queries.myNotifications = async function () {
  try {
    let response = await graphQL(`
    query MyNotifications {
      me {
        unseenNotificationsCount
        notifications {
          date
          notification_type
          variables
        }
      }
    }`);
    return response.data
  } catch (ex) {
    throw ex
  }
}
queries.checkForUnseenNotifications = async function () {
  try {
    let response = await graphQL(`
    query MyUnseenNotifications {
      me {
        unseenNotificationsCount
      }
    }`);
    return response.data
  } catch (ex) {
    throw ex
  }
}

queries.myThreads = async function () {
  try {
    let response = await graphQL(`
    query MyThreads {
      threads {
        id
        is_unread
        users {
          id
          first_name
          last_name
          avatar
        }
        messages {
          id
          body
          created_at
          user {
            id
            avatar
            first_name
            last_name
          }
        }
      }
    }`);
    return response.data
  } catch (ex) {
    throw ex
  }
}
queries.checkUnreadThreads = async function () {
  try {
    let response = await graphQL(`
    query CheckUnreadThreads {
      threads {
        id
        is_unread
      }
    }`);
    return response.data
  } catch (ex) {
    throw ex
  }
}

queries.getMessagesFromThread = async function (id) {
  try {
    let response = await graphQL(`
    query GetMessages($id: Int) {
      threads(id: $id) {
        id
        messages {
          id
          body
          created_at
          user {
            id
            avatar
            first_name
            last_name
          }
        }
      }
    }`, { id });
    return response.data
  } catch (ex) {
    throw ex
  }
}

queries.myObjects = async function () {
  try {
    let response = await graphQL(`
    query MyObjects {
      me {
        unseenNotificationsCount
        notifications {
          date
          notification_type
          variables
        }
        families {
          children {
            games {
              id
              game
              played_at
              score
              secure_key
            }
          }
        }
      }
    }`);
    return response.data
  } catch (ex) {
    throw ex
  }
}

/*
        children {
          games {
            id
            game
            score
            secure_key
          }
        }
*/

// Mutations
mutations.createUser = async function (user) {
  try {
    let response = await graphQL(`
    mutation CreateUser($email: String!, $password: String!, $first_name: String!, $last_name: String!, $gender: String!, $title: String, $account_type: String) {
      newUser(
        email: $email
        password: $password
        first_name: $first_name
        last_name: $last_name
        gender: $gender
        title: $title
        account_type: $account_type
      ) {
        identifier
      }
    }`, user);
    return response.data
  } catch (ex) {
    throw ex
  }
}
mutations.updateMe = async function (user) {
  try {
    let response = await graphQL(`
    mutation UpdateMe($notif_mail: String, $notif_sms: String, $email: String, $phone: String, $first_name: String, $last_name: String, $gender: String, $birthdate: String, $avatar: String, $title: String) {
      updateMe(
        email: $email
        phone: $phone
        first_name: $first_name
        last_name: $last_name
        gender: $gender
        birthdate: $birthdate
        avatar: $avatar
        title: $title
        notif_mail: $notif_mail
        notif_sms: $notif_sms
      ) {
        email
        phone
        title
        first_name
        last_name
        gender
        birthdate
        avatar
        notif_mail
        notif_sms
      }
    }`, user);
    return response.data
  } catch (ex) {
    throw ex
  }
}
mutations.resetNotificationsCount = async function () {
  try {
    let response = await graphQL(`
    mutation ResetNotificationsCount {
      updateNotifCount
    }`);
    return response.data
  } catch (ex) {
    throw ex
  }
}
mutations.seenLibrary = async function () {
  try {
    let response = await graphQL(`
    mutation SeenLibrary {
      seenLibrary
    }`);
    return response.data
  } catch (ex) {
    throw ex
  }
}
mutations.playGame = async function (fields) {
  try {
    let response = await graphQL(`
    mutation UpdateGameStatus($id: Int!) {
      updateGameStatus (
        id: $id
      )
    }`, fields);
    return response.data
  } catch (ex) {
    throw ex
  }
}
mutations.markThreadAsRead = async function (id) {
  try {
    let response = await graphQL(`
    mutation MarhThreadAsRead($id: Int!) {
      readThread (
        thread_id: $id
      )
    }`, { id });
    return response.data
  } catch (ex) {
    throw ex
  }
}

// TODO
mutations.createSubUser = async function (user) {
  try {
    let response = await graphQL(`
    mutation CreateSubUser (
      $identifier: String!
      $account_type: String!,
      $email: String,
      $password: String!,
      $first_name: String!,
      $last_name: String!,
      $gender: String!,
      $birthdate: String!) {
      newSubUser(
        identifier: $identifier,
        account_type: $account_type
        email: $email
        password: $password
        first_name: $first_name
        last_name: $last_name
        gender: $gender
        birthdate: $birthdate
      ) {
        id
        account_type
        avatar
        first_name
        last_name
        email
        phone
        identifier
        birthdate
        signup_date
        rights
        notif_mail
        notif_sms
        auto_evaluations {
          date
          value
        }
        games {
          id
          game
          score
          secure_key
        }
      }
    }`, user);

    return response.data
  } catch (ex) {
    throw ex
  }
}
mutations.deleteSubUser = async function (userId) {
  try {
    let response = await graphQL(`
    mutation deleteSubUser ($id: Int!) {
      deleteSubUser(
        id: $id
      )
    }`, { id: userId })

    return response.data;
  } catch (ex) {
    throw ex
  }
}
mutations.setAuthorizations = async function(args) {
  try {
    let response = await graphQL(`
    mutation SetAuthorizations ($id: Int!, $can: String) {
      setAuthorizations(
        id: $id
        can: $can
      ) {
        id
      }
    }`, args)

    return response.data;
  } catch (ex) {
    throw ex
  }
}
mutations.removeFromFamily = async function(args) {
  try {
    let response = await graphQL(`
    mutation RemoveFromFamily ($caregiverId: Int!, $familyId: Int!) {
      removeFromFamily(
        caregiverId: $caregiverId
        familyId: $familyId
      ) {
        id
      }
    }`, args)

    return response.data;
  } catch (ex) {
    throw ex
  }
}

mutations.deleteMe = async function () {
  try {
    let response = await graphQL(`
    mutation DeleteMe {
      deleteMe
    }`);

    return response.data;
  } catch (ex) {
    throw ex
  }
}
mutations.sendInvitation = async function ({ role, identifier }) {
  try {
    let response = await graphQL(`
    mutation SendInvitation ($role: String!, $identifier: String!) {
      sendInvitation(
        role: $role
        identifier: $identifier
      )
    }`, { role, identifier })

    return response.data;
  } catch (ex) {
    throw ex
  }
}
mutations.createAutoEvaluation = async function ({ value, comment }) {
  try {
    let response = await graphQL(`
    mutation CreateAutoEvaluation (
      $value: Int!
      $variables: String!
      ) {
      newAutoEvaluation(
        value: $value
        variables: $variables
      ) {
        value
      }
    }`, { value, variables: JSON.stringify({ comment }) });

    return response.data
  } catch (ex) {
    throw ex
  }
}
mutations.updateSubUser = async function (user) {
  try {
    let response = await graphQL(`
    mutation UpdateSubUser (
      $id: String!
      $email: String,
      $phone: String,
      $password: String,
      $first_name: String,
      $last_name: String,
      $gender: String,
      $notif_mail: String,
      $notif_sms: String,
      $permissions: [String],
      $birthdate: String) {
      updateSubUser(
        id: $id,
        email: $email
        phone: $phone
        password: $password
        first_name: $first_name
        last_name: $last_name
        gender: $gender
        birthdate: $birthdate
        notif_mail: $notif_mail
        notif_sms: $notif_sms
        permissions: $permissions
      ) {
        id
        identifier
        account_type
        email
        phone
        birthdate
        first_name
        last_name
        notif_mail
        notif_sms
        rights
      }
    }`, user);

    return response.data
  } catch (ex) {
    throw ex
  }
}
mutations.createAppointment = async function (appointment) {
  let time =  appointment.time.split(':').map(i => parseInt(i));
  let datetime = appointment.date;
  datetime.setHours(...time);
  appointment.datetime = datetime.toISOString().slice(0, 19).replace('T', ' ');

  try {
    let response = await graphQL(`
    mutation createAppointment (
      $title: String,
      $comment: String,
      $appointment_type: String!,
      $datetime: String!) {
      newAppointment(
        title: $title
        comment: $comment
        appointment_type: $appointment_type
        date: $datetime
      ) {
        id
        title
        appointment_type
        date
        comment
      }
    }`, appointment)

    return response.data;
  } catch (ex) {
    throw ex
  }
}
mutations.updateAppointment = async function (appointment) {
  appointment.datetime = appointment.date + " " + appointment.time

  try {
    let response = await graphQL(`
    mutation updateAppointment (
      $id: Int!,
      $title: String,
      $comment: String,
      $appointment_type: String,
      $datetime: String) {
      updateAppointment(
        title: $title
        comment: $comment
        appointment_type: $appointment_type
        date: $datetime
      ) {
        id
        title
        appointment_type
        date
        comment
      }
    }`, appointment)

    return response.data;
  } catch (ex) {
    throw ex
  }
}
mutations.deleteAppointment = async function (appointment) {
  try {
    let response = await graphQL(`
    mutation deleteAppointment (
      $id: Int!) {
      deleteAppointment(
        id: $id
      )
    }`, appointment)

    return response.data;
  } catch (ex) {
    throw ex
  }
}
//
// Mutations
mutations.newMessage = async function (message) {
  try {
    let response = await graphQL(`
    mutation NewMessage($threadId: Int!, $message: String!) {
      newMessage(
        thread_id: $threadId
        body: $message
      ) {
        id
        body
        created_at
        user {
          id
          avatar
          first_name
          last_name
        }
      }
    }`, message);

    return response.data
  } catch (ex) {
    throw ex
  }
}
mutations.sendContact = async function (fields) {
  try {
    let response = await graphQL(`
    mutation SendContact($id: String!, $fields: String!) {
      sendMail(
        id: $id
        fields: $fields
      )
    }`, { id: 'contact', fields: JSON.stringify(fields) });

    return response.data
  } catch (ex) {
    throw ex
  }
}
mutations.sendSuggestion = async function (fields) {
  try {
    let response = await graphQL(`
    mutation SendSuggestion($id: String!, $fields: String!) {
      sendMail(
        id: $id
        fields: $fields
      )
    }`, { id: 'suggestion', fields: JSON.stringify(fields) });

    return response.data
  } catch (ex) {
    throw ex
  }
}
mutations.sendNewsletter = async function ({ email }) {
  try {
    let response = await graphQL(`
    mutation SendNewsletter($id: String!, $email: String!) {
      sendApi(
        id: $id
        email: $email
      )
    }`, { id: 'newsletter', email });
    return response.data
  } catch (ex) {
    throw ex
  }
}
mutations.sendFilRouge = async function ({ email, firstname, lastname }) {
  try {
    let response = await graphQL(`
    mutation SendFilRouge($id: String!, $email: String!, $firstname: String, $lastname: String) {
      sendApi(
        id: $id
        email: $email
        firstname: $firstname
        lastname: $lastname
      )
    }`, { id: 'filrouge', email, firstname, lastname });
    return response.data
  } catch (ex) {
    throw ex
  }
}
mutations.sendFilRouge = async function ({ email, firstname, lastname }) {
  try {
    let response = await graphQL(`
    mutation SendFilRouge($id: String!, $email: String!, $firstname: String, $lastname: String) {
      sendApi(
        id: $id
        email: $email
        firstname: $firstname
        lastname: $lastname
      )
    }`, { id: 'filrouge', email, firstname, lastname });
    return response.data
  } catch (ex) {
    throw ex
  }
}
mutations.sendResetPasswordInstructions = async function ({ email }) {
  try {
    let response = await graphQL(`
    mutation SendResetPasswordInstructions($email: String!) {
      sendResetPasswordInstructions(
        email: $email
      )
    }`, { email });
    return response.data
  } catch (ex) {
    throw ex
  }
}
mutations.resetPassword = async function ({ password, token }) {
  try {
    let response = await graphQL(`
    mutation ResetPassword($password: String!, $token: String!) {
      resetPassword(
        password: $password
        token: $token
      )
    }`, { password, token });
    return response.data
  } catch (ex) {
    throw ex
  }
}

export {
  queries,
  mutations
}
